/* Collection + search results behaviour (group C): sort dropdown, filters aside (groups, pseudo-checkboxes, price slider,
   clear/apply), Reference-mode client-side sort/filter/load-more on the seeded tiles, Shopify-mode navigation and
   section-rendered load-more, sticky toolbar state, tabs, back to top. Initialised through TC.init on load and editor reload. */
(function () {
  'use strict';
  function qs(el, s) { return el.querySelector(s); }
  function qsa(el, s) { return Array.prototype.slice.call(el.querySelectorAll(s)); }
  function fmt(n, cur) { n = Math.round(Number(n) || 0); return (cur || '$') + n.toLocaleString('en-US'); }
  function digits(v) { return Number(String(v || '').replace(/[^0-9.]/g, '')) || 0; }

  function init(root) {
    var mode = root.getAttribute('data-tc-mode') || 'reference';
    var list = qs(root, '[data-tc-grid-list]');
    var header = qs(root, '[data-tc-grid-header]');
    var modal = qs(root, '[data-tc-filters]');
    var loadMore = qs(root, '[data-tc-load-more]');
    var loadInfo = qs(root, '[data-tc-load-info]');
    var noResults = qs(root, '[data-tc-no-results]');
    var state = { sort: root.getAttribute('data-tc-sort') || 'recommended', filters: {}, price: null, personal: false, step: loadMore ? Number(loadMore.getAttribute('data-tc-step')) || 12 : 12, visible: 0 };
    var tiles = function () { return list ? qsa(list, '[data-tc-tile]') : []; };
    var promos = function () { return list ? qsa(list, '[data-tc-promo]') : []; };
    state.visible = tiles().filter(function (t) { return !t.classList.contains('d-none'); }).length || state.step;

    /* ---------- sticky toolbar ---------- */
    var sentinel = qs(root, '[data-tc-sticky-sentinel]');
    if (header && sentinel && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { header.classList.toggle('stuck', !entries[0].isIntersecting); }, { threshold: 0 }).observe(sentinel);
    }

    /* ---------- sort dropdown ---------- */
    var sort = qs(root, '[data-tc-sort]');
    if (sort) {
      var toggle = qs(sort, '[data-tc-sort-toggle]'), menu = qs(sort, '[data-tc-sort-menu]');
      var open = function (on) { menu.style.display = on ? 'block' : 'none'; sort.classList.toggle('custom-dropdown--active', on); toggle.setAttribute('aria-expanded', on ? 'true' : 'false'); };
      toggle.addEventListener('click', function () { open(menu.style.display === 'none'); });
      document.addEventListener('click', function (e) { if (!sort.contains(e.target)) open(false); });
      sort.addEventListener('keydown', function (e) { if (e.key === 'Escape') { open(false); toggle.focus(); } });
      qsa(menu, '[data-tc-sort-value]').forEach(function (opt) {
        opt.addEventListener('click', function () {
          var value = opt.getAttribute('data-tc-sort-value');
          qsa(menu, '[data-tc-sort-value]').forEach(function (o) { o.classList.toggle('custom-dropdown__option--selected', o === opt); o.setAttribute('aria-selected', o === opt ? 'true' : 'false'); });
          open(false);
          if (sort.getAttribute('data-tc-sort-mode') === 'shopify') {
            var url = new URL(sort.getAttribute('data-tc-sort-url') || window.location.pathname, window.location.origin);
            new URLSearchParams(window.location.search).forEach(function (v, k) { if (k !== 'page' && k !== 'sort_by') url.searchParams.append(k, v); });
            if (value !== 'recommended') url.searchParams.set('sort_by', value);
            window.location.assign(url.toString());
            return;
          }
          state.sort = value; applyReference();
        });
      });
    }

    /* ---------- reference mode: sort + filter + reveal ---------- */
    function matches(tile) {
      if (tile.getAttribute('data-tc-nomatch')) return false;
      for (var attr in state.filters) {
        var wanted = state.filters[attr]; if (!wanted.length) continue;
        if (wanted.indexOf((tile.getAttribute('data-tc-' + attr) || '').toLowerCase()) === -1) return false;
      }
      if (state.price) { var p = Number(tile.getAttribute('data-tc-price')) || 0; if (p < state.price[0] || p > state.price[1]) return false; }
      if (state.personal && !tile.getAttribute('data-tc-personal')) return false;
      return true;
    }
    function sorted() {
      var all = tiles();
      var byIndex = function (a, b) { return Number(a.getAttribute('data-tc-index')) - Number(b.getAttribute('data-tc-index')); };
      if (state.sort === 'price-ascending') all.sort(function (a, b) { return Number(a.getAttribute('data-tc-price')) - Number(b.getAttribute('data-tc-price')) || byIndex(a, b); });
      else if (state.sort === 'price-descending') all.sort(function (a, b) { return Number(b.getAttribute('data-tc-price')) - Number(a.getAttribute('data-tc-price')) || byIndex(a, b); });
      else if (state.sort === 'created-descending') all.sort(function (a, b) { return byIndex(b, a); });
      else all.sort(byIndex);
      return all;
    }
    function filtering() { return state.personal || state.price !== null || Object.keys(state.filters).some(function (k) { return state.filters[k].length; }); }
    function paintInfo(shown, total) {
      if (!loadInfo) return;
      var tpl = loadInfo.getAttribute('data-tc-showing-template') || 'Showing __F__ - __T__ of __N__';
      var p = qs(loadInfo, 'p'); if (p) p.textContent = tpl.replace('__F__', shown ? '1' : '0').replace('__T__', String(shown)).replace('__N__', String(total));
    }
    function applyReference(keepVisible) {
      if (!list) return;
      var ordered = sorted(), matched = [], count = 0;
      var limit = keepVisible ? state.visible : state.step; state.visible = limit;
      var sortedOrder = state.sort !== 'recommended';
      ordered.forEach(function (t) {
        var ok = matches(t); t.classList.toggle('tc-nomatch-live', !ok);
        if (ok) { matched.push(t); count++; var show = count <= limit; t.classList.toggle('d-none', !show); t.classList.toggle('tc-more', !show); } else { t.classList.add('d-none'); t.classList.remove('tc-more'); }
      });
      /* promo tiles keep their place in the recommended, unfiltered order and hide while the merchant's customer sorts or filters */
      promos().forEach(function (p) { p.classList.toggle('d-none', sortedOrder || filtering()); });
      if (sortedOrder) ordered.forEach(function (t) { list.appendChild(t); });
      else { var all = qsa(list, 'li'); all.sort(function (a, b) { return Number(a.getAttribute('data-tc-order') || 0) - Number(b.getAttribute('data-tc-order') || 0); }); all.forEach(function (t) { list.appendChild(t); }); }
      var shown = Math.min(count, limit);
      var total = filtering() ? count : Number(loadInfo && loadInfo.getAttribute('data-tc-total')) || count;
      paintInfo(shown, total);
      if (loadMore) loadMore.disabled = shown >= count;
      if (noResults) noResults.classList.toggle('d-none', count > 0);
      root.classList.toggle('no-results', count === 0);
      paintApplyCount(count);
    }
    if (list) qsa(list, 'li').forEach(function (li, i) { if (!li.getAttribute('data-tc-order')) li.setAttribute('data-tc-order', String(i)); });

    /* ---------- filters aside ---------- */
    function paintApplyCount(n) {
      var apply = modal && qs(modal, '[data-tc-apply]'); if (!apply || mode !== 'reference') return;
      var tpl = apply.getAttribute('data-tc-count-template') || 'View __N__ items'; apply.textContent = tpl.replace('__N__', String(n));
    }
    function pendingCount() { return tiles().filter(matches).length; }
    if (modal) {
      qsa(modal, '[data-tc-collapsible-toggle]').forEach(function (btn) {
        var panel = btn.closest('[data-tc-collapsible]');
        var setOpen = function (on) {
          panel.classList.toggle('active', on); btn.setAttribute('aria-expanded', on ? 'true' : 'false');
          if (on) { var head = qs(panel, '.collapsible-header'), body = qs(panel, '.collapsible-body'); panel.style.height = ((head ? head.offsetHeight : 0) + (body ? body.scrollHeight : 0)) + 'px'; } else panel.style.height = '';
        };
        btn.addEventListener('click', function () { setOpen(!panel.classList.contains('active')); });
        if (panel.classList.contains('active')) setTimeout(function () { setOpen(true); }, 0);
      });
      /* reference values */
      qsa(modal, '[data-tc-ref-filter]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var on = btn.getAttribute('aria-pressed') !== 'true'; btn.setAttribute('aria-pressed', on ? 'true' : 'false'); btn.classList.toggle('selected', on);
          var attr = btn.getAttribute('data-tc-attr'), value = btn.getAttribute('data-tc-value');
          state.filters[attr] = state.filters[attr] || [];
          if (on) state.filters[attr].push(value); else state.filters[attr] = state.filters[attr].filter(function (v) { return v !== value; });
          var countEl = qs(btn.closest('[data-tc-collapsible]'), '[data-tc-group-count]'); if (countEl) { countEl.textContent = String(state.filters[attr].length); countEl.classList.toggle('show', state.filters[attr].length > 0); }
          paintApplyCount(pendingCount());
        });
      });
      /* shopify checkboxes: paint the selected look + group count */
      qsa(modal, '[data-tc-check] input[type=checkbox]').forEach(function (cb) {
        cb.addEventListener('change', function () {
          cb.closest('[data-tc-check]').classList.toggle('selected', cb.checked);
          var panel = cb.closest('[data-tc-collapsible]'); var countEl = panel && qs(panel, '[data-tc-group-count]');
          if (countEl) { var n = qsa(panel, 'input[type=checkbox]:checked').length; countEl.textContent = String(n); countEl.classList.toggle('show', n > 0); }
        });
      });
      /* price slider */
      qsa(modal, '[data-tc-price-range]').forEach(function (range) {
        var min = Number(range.getAttribute('data-min')) || 0, max = Number(range.getAttribute('data-max')) || 0, cur = range.getAttribute('data-currency') || '$';
        var lo = qs(range, '[data-tc-range="min"]'), hi = qs(range, '[data-tc-range="max"]'), tlo = qs(range, '[data-tc-price-text="min"]'), thi = qs(range, '[data-tc-price-text="max"]');
        var flo = qs(range, '[data-tc-price-field="min"]'), fhi = qs(range, '[data-tc-price-field="max"]');
        var olo = qs(range, '[data-tc-origin="min"]'), ohi = qs(range, '[data-tc-origin="max"]'), connect = qs(range, '[data-tc-connect]');
        if (!lo || !hi) return;
        var paint = function () {
          var a = Number(lo.value), b = Number(hi.value); if (a > b) { var t = a; a = b; b = t; }
          var span = Math.max(1, max - min), pa = (a - min) / span * 100, pb = (b - min) / span * 100;
          if (olo) olo.style.transform = 'translate(' + (pa - 100) + '%, 0px)';
          if (ohi) ohi.style.transform = 'translate(' + (pb - 100) + '%, 0px)';
          if (connect) connect.style.transform = 'translate(' + pa + '%, 0px) scale(' + ((pb - pa) / 100) + ', 1)';
          if (tlo && document.activeElement !== tlo) tlo.value = fmt(a, cur);
          if (thi && document.activeElement !== thi) thi.value = fmt(b, cur);
          if (flo) flo.value = a > min ? String(a) : '';
          if (fhi) fhi.value = b < max ? String(b) : '';
          state.price = (a > min || b < max) ? [a, b] : null;
          if (mode === 'reference') paintApplyCount(pendingCount());
        };
        lo.addEventListener('input', paint); hi.addEventListener('input', paint);
        var fromText = function () { var a = digits(tlo && tlo.value), b = digits(thi && thi.value); if (tlo) lo.value = String(Math.min(Math.max(a, min), max)); if (thi) hi.value = String(Math.min(Math.max(b || max, min), max)); paint(); };
        [tlo, thi].forEach(function (inp) { if (inp) { inp.addEventListener('change', fromText); inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); fromText(); } }); } });
        paint();
      });
      /* mobile personalize copy */
      var pm = qs(modal, '[data-tc-personalize-mobile]'), pd = qs(root, '[data-tc-personalize]');
      if (pm && mode === 'reference') pm.addEventListener('change', function () { state.personal = pm.checked; if (pd) pd.checked = pm.checked; paintApplyCount(pendingCount()); });
      /* clear / apply */
      var clear = qs(modal, '[data-tc-clear]');
      if (clear) clear.addEventListener('click', function () {
        if (mode === 'shopify') { var form = qs(modal, '[data-tc-filter-form]'); window.location.assign(form.getAttribute('data-tc-clear-url') || window.location.pathname); return; }
        state.filters = {}; state.price = null; state.personal = false;
        qsa(modal, '[data-tc-ref-filter]').forEach(function (b) { b.classList.remove('selected'); b.setAttribute('aria-pressed', 'false'); });
        qsa(modal, '[data-tc-group-count]').forEach(function (c) { c.textContent = '0'; c.classList.remove('show'); });
        qsa(modal, '[data-tc-price-range]').forEach(function (r) { var lo = qs(r, '[data-tc-range="min"]'), hi = qs(r, '[data-tc-range="max"]'); if (lo) { lo.value = lo.min; lo.dispatchEvent(new Event('input')); } if (hi) { hi.value = hi.max; hi.dispatchEvent(new Event('input')); } });
        if (pm) pm.checked = false; if (pd) pd.checked = false;
        applyReference();
      });
      var apply = qs(modal, '[data-tc-apply]');
      if (apply && mode === 'reference') apply.addEventListener('click', function () { applyReference(); if (window.TC && TC.overlay) TC.overlay.close(modal); });
      root.addEventListener('tc:editor:state', function (e) { if (e.detail === 'filters' && window.TC && TC.overlay && !TC.overlay.isOpen(modal)) TC.overlay.open(modal); });
    }

    /* ---------- personalize (toolbar) ---------- */
    var personalize = qs(root, '[data-tc-personalize]');
    if (personalize) personalize.addEventListener('change', function () {
      if (mode === 'shopify') {
        var url = new URL(window.location.href); var tag = personalize.getAttribute('data-tc-tag') || 'personalizable';
        var tags = url.searchParams.getAll('filter.p.tag').filter(function (t) { return t !== tag; }); url.searchParams.delete('filter.p.tag'); url.searchParams.delete('page');
        tags.forEach(function (t) { url.searchParams.append('filter.p.tag', t); }); if (personalize.checked) url.searchParams.append('filter.p.tag', tag);
        window.location.assign(url.toString()); return;
      }
      state.personal = personalize.checked; var pm2 = modal && qs(modal, '[data-tc-personalize-mobile]'); if (pm2) pm2.checked = personalize.checked; applyReference();
    });

    /* ---------- load more ---------- */
    if (loadMore) loadMore.addEventListener('click', function () {
      if (mode === 'reference') { state.visible += state.step; applyReference(true); return; }
      var next = loadMore.getAttribute('data-tc-next'); if (!next) { loadMore.disabled = true; return; }
      var url = new URL(next, window.location.origin); url.searchParams.set('section_id', root.getAttribute('data-tc-section'));
      loadMore.disabled = true; loadMore.classList.add('tc-loading');
      fetch(url.toString(), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = qsa(doc, '[data-tc-grid-list] > li'); items.forEach(function (li) { list.appendChild(document.importNode(li, true)); });
        var newBtn = qs(doc, '[data-tc-load-more]'); var newNext = newBtn ? newBtn.getAttribute('data-tc-next') : '';
        loadMore.setAttribute('data-tc-next', newNext || ''); loadMore.disabled = !newNext; loadMore.classList.remove('tc-loading');
        var shown = tiles().length; paintInfo(shown, Number(loadInfo && loadInfo.getAttribute('data-tc-total')) || shown);
        if (window.history && history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('page', new URL(next, window.location.origin).searchParams.get('page') || '2'); history.replaceState(null, '', u.toString()); }
      }).catch(function () { window.location.assign(next); });
    });

    /* ---------- back to top ---------- */
    var top = qs(root, '[data-tc-back-to-top]');
    if (top) top.addEventListener('click', function () { var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' }); });

    /* ---------- tabs (search) ---------- */
    qsa(root, '[data-tc-tab]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault(); var target = qs(root, link.getAttribute('href'));
        qsa(root, '[data-tc-tab]').forEach(function (l) { l.classList.toggle('active', l === link); l.setAttribute('aria-selected', l === link ? 'true' : 'false'); });
        qsa(root, '[data-tc-tab-pane]').forEach(function (p) { var on = p === target; p.classList.toggle('active', on); p.classList.toggle('show', on); });
        root.classList.toggle('tc-content-tab-active', link.hasAttribute('data-tc-tab-content'));
      });
    });

    if (mode === 'reference') { paintInfo(Math.min(state.visible, tiles().filter(function (t) { return !t.getAttribute('data-tc-nomatch'); }).length), Number(loadInfo && loadInfo.getAttribute('data-tc-total')) || 0); paintApplyCount(pendingCount()); }
  }
  if (window.TC && TC.init) TC.init('[data-tc-plp]', init);
  else document.addEventListener('DOMContentLoaded', function () { Array.prototype.forEach.call(document.querySelectorAll('[data-tc-plp]'), init); });
})();
